import VState from 'signal/v-state'

const urlUploadWebSocketState = new VState()

export default urlUploadWebSocketState